import { GeneratedVideoModels, IAssetInDTO, ILocalAsset } from './assets.model';
import { AssetType } from '../defines';

class AssetsConverter {
    public convertArrayOfInAssetsToLocal(assets: IAssetInDTO[]): ILocalAsset[] {
        const localAssets = assets.map((inAssets) => this.convertInAssetToLocal(inAssets));
        return localAssets;
    }
    public convertInAssetToLocal(asset: IAssetInDTO) {
        let canExtendDuration: boolean = false;
        const assetModel = asset.generatedBy;

        if (assetModel === GeneratedVideoModels.VEO && asset.type === AssetType.VIDEO) {
            canExtendDuration = true;
        }
        let isImage = false;
        if (asset.type === AssetType.IMAGE) {
            isImage = true;
        }
        const localAsset: ILocalAsset = {
            _id: asset._id,
            dashPath: asset.dashPath,
            displayName: asset.displayName ?? asset.folder,
            createdAt: asset.createdAt,
            folder: asset.folder,
            generatedBy: assetModel,
            type: asset.type,
            mimetype: asset.mimetype,
            userEmail: asset.userEmail,
            uploadPath: asset.uploadPath,
            canExtendDuration: canExtendDuration,
            isImage: isImage,
        };
        return localAsset;
    }
}

export const assetConverter = new AssetsConverter();
